"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SounditiApi_1 = __importDefault(require("../SounditiApi"));
var Auth_1 = __importDefault(require("../Auth"));
var defaults_1 = __importDefault(require("../defaults"));
var logger_1 = __importDefault(require("../utils/logger"));
var errors_1 = require("../utils/errors");
var utils_1 = require("../utils/utils");
var dexie_db_1 = __importDefault(require("./dexie-db"));
var fetch_progress_1 = __importDefault(require("fetch-progress"));
var logger = logger_1.default('campaign-access');
var PanelAccess = /** @class */ (function () {
    /**
     *
     * @param {DataLayerConfiguration} options
     * @param {token} [options.token = ''] | An access token
     * @param {host} [options.hosts = defaults.host] | An access token
     *
     */
    function PanelAccess(_a) {
        var _b = (_a === void 0 ? {} : _a).hosts, hosts = _b === void 0 ? defaults_1.default : _b;
        this._authRenewal = utils_1.tokenRenewal;
        this.auth = new Auth_1.default({ auth_host: hosts.auth_host });
        this.token = this.auth.getToken() || '';
        this.api = new SounditiApi_1.default({ token: this.token, hosts: hosts });
    }
    PanelAccess.prototype.login = function (email, password, code) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, tokenPair, decoded, user, logged, token, token_expiration, loginRes, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.auth.controlPanelLogin(email, password, this.api.hosts.panel_host, code)];
                    case 1:
                        _a = _b.sent(), tokenPair = _a.auth, decoded = _a.decoded, user = _a.user, logged = _a.logged;
                        if (logged) {
                            return [2 /*return*/, { logged: logged }];
                        }
                        else {
                            token = tokenPair.accessToken;
                            token_expiration = decoded.exp;
                            this.api.token = token;
                            loginRes = {
                                user: user,
                                token: token,
                                token_expiration: token_expiration,
                            };
                            return [2 /*return*/, loginRes];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        throw new errors_1.LoginError(error_1.message);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates action for posterior analisys and data visualization
     *
     * It never throws as we only want to put data on the server
     *
     * @param {string} type The type of action
     * @param {string} screen The screen where postAction was called
     * @param {string} device The device type: mobile or desktop
     * @param {string} browser The browser used
     * @param {string} sessionId The session identifier
     * @param {string} createdAt The timestamp when the action was created
     *
     * @returns {Promise<NewActionResponse>} TODO: should return nothing in production.
     *
     * @throws {NotValidAction} When trying to post an action not defined by the backend.
     */
    PanelAccess.prototype.postAction = function (type, screen, device, browser, sessionId, createdAt, data) {
        if (device === void 0) { device = null; }
        if (browser === void 0) { browser = null; }
        if (sessionId === void 0) { sessionId = null; }
        if (createdAt === void 0) { createdAt = null; }
        if (data === void 0) { data = null; }
        return __awaiter(this, void 0, void 0, function () {
            var res, action, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.api.postPanelAction(type, screen, device, browser, sessionId, createdAt, data)];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, res.json()];
                    case 2:
                        action = _a.sent();
                        return [2 /*return*/, action];
                    case 3:
                        error_2 = _a.sent();
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Gets statistics of new users created between a date range
     *
     * @param {string} sinceDAte date from which you want to make the query
     * @param {string} untilDate date until which you want to make the query
     * @example
     * format data "2021-06-15"
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<NewUsers>} An object with the following information: numDays, untilDate, sinceDate, newUsers
     *
     * @throws {PermissionError} 403 responses or bad token
     * @throws {Error} 40X General error
     */
    PanelAccess.prototype.getUsersCreated = function (listUsersCampaignsCreatedRequest, renew) {
        if (listUsersCampaignsCreatedRequest === void 0) { listUsersCampaignsCreatedRequest = {}; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_1, e, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.getUsersCreated(listUsersCampaignsCreatedRequest)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('getUsersCreated from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getUsersCreated(listUsersCampaignsCreatedRequest, false)];
                    case 5:
                        res_1 = _a.sent();
                        return [2 /*return*/, res_1];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('getUsersCreated status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_3 = _a.sent();
                        logger.error('Error getUsersCreated', { msg: error_3.message, name: error_3.name });
                        throw new Error(error_3.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets stats of new users and their campaigns between a date range
     *
     * @param {string} sinceDAte date from which you want to make the query
     * @param {string} untilDate date until which you want to make the query
     * @example
     * format data "2021-06-15"
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<NewUsersCampaigns>} An object with the following information: numDays, untilDate, sinceDate, newUsers, campaignsCreatedByNewUsers, enrolledTestersInCampaignsCreatedByNewUsers
     *
     * @throws {PermissionError} 403 responses or bad token
     * @throws {Error} 40X General error
     */
    PanelAccess.prototype.getCampaignsCreated = function (listUsersCampaignsCreatedRequest, renew) {
        if (listUsersCampaignsCreatedRequest === void 0) { listUsersCampaignsCreatedRequest = {}; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_2, e, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.getCampaignsCreated(listUsersCampaignsCreatedRequest)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('getCampaignsCreated from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getCampaignsCreated(listUsersCampaignsCreatedRequest, false)];
                    case 5:
                        res_2 = _a.sent();
                        return [2 /*return*/, res_2];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('getCampaignsCreated status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_4 = _a.sent();
                        logger.error('Error getCampaignsCreated', { msg: error_4.message, name: error_4.name });
                        throw new Error(error_4.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates an user Object
     *
     * @param {UserItem} updatedUserRequest
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<UserItem>}
     *
     * @throws {PermissionError} 403 responses or bad token
     * @throws {Error} 40X General error
     */
    PanelAccess.prototype.updateUser = function (updatedUserRequest, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_3, e, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.updateUserItem(updatedUserRequest)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('updateUser from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.updateUser(updatedUserRequest, false)];
                    case 5:
                        res_3 = _a.sent();
                        return [2 /*return*/, res_3];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('updateUser status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_5 = _a.sent();
                        logger.error('Error updateUser', { msg: error_5.message, name: error_5.name });
                        throw new Error(error_5.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get all subscriptions
     *
     * @returns {Promise<Subscription[]>} The list of subscriptions
     *
     * @throws {PermissionError} Auth token not valid
     */
    PanelAccess.prototype.getAllSubscriptions = function (renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_4, e, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.getAllSubscriptions()];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('getAllSubscriptions from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getAllSubscriptions(false)];
                    case 5:
                        res_4 = _a.sent();
                        return [2 /*return*/, res_4];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('getAllSubscriptions status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_6 = _a.sent();
                        logger.error('Error getAllSubscriptions', { msg: error_6.message, name: error_6.name });
                        throw new Error(error_6.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates a subscription
     *
     * @param {Subscription} subscription
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<Subscription>}
     *
     * @throws {PermissionError} 403 responses or bad token
     * @throws {Error} 40X General error
     */
    PanelAccess.prototype.updateSubscription = function (subscription, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_5, e, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.updateSubscription(subscription)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('updateSubscription from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.updateSubscription(subscription, false)];
                    case 5:
                        res_5 = _a.sent();
                        return [2 /*return*/, res_5];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('updateSubscription status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_7 = _a.sent();
                        logger.error('Error updateSubscription', { msg: error_7.message, name: error_7.name });
                        throw new Error(error_7.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get all the interactions of a specific email
     *
     * @param {string} campaignId The campaign identifier
     * @param {string} email The email of the tester
     *
     * @returns {Promise<InteractionItem[]>} The list of the interactions of the tester
     
     * @throws {PermissionError} 403 responses or bad token
     * @throws {Error} 40X General error
     */
    PanelAccess.prototype.getInteractionsByEmail = function (campaignId, email, breakpoints, renew) {
        if (breakpoints === void 0) { breakpoints = 121; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_6, e, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.getInteractionsByEmail(campaignId, email, breakpoints)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('getInteractionsByEmail from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getInteractionsByEmail(campaignId, email, breakpoints, false)];
                    case 5:
                        res_6 = _a.sent();
                        return [2 /*return*/, res_6];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('getInteractionsByEmail status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_8 = _a.sent();
                        logger.error('Error getInteractionsByEmail', { msg: error_8.message, name: error_8.name });
                        throw new Error(error_8.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This function returns all the actios of a particular email
     *
     * @param {string} email The email of the tester
     * @param {number} sinceDate The begin timestamp
     * @param {number} untilDate The final timestamp
     */
    PanelAccess.prototype.listActionsByEmail = function (actionsByEmailRequest, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_7, e, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.listActionsByEmail(actionsByEmailRequest)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('listActionsByEmail from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.listActionsByEmail(actionsByEmailRequest, false)];
                    case 5:
                        res_7 = _a.sent();
                        return [2 /*return*/, res_7];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('listActionsByEmail status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_9 = _a.sent();
                        logger.error('Error listActionsByEmail', { msg: error_9.message, name: error_9.name });
                        throw new Error(error_9.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This function returns all the actios of a particular tool
     *
     * @param {string} tool The tool
     *
     */
    PanelAccess.prototype.listAllActions = function (tool, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_8, e, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.listAllActions(tool)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('listAllActions from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.listAllActions(tool, false)];
                    case 5:
                        res_8 = _a.sent();
                        return [2 /*return*/, res_8];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('listAllActions status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_10 = _a.sent();
                        logger.error('Error listAllActions', { msg: error_10.message, name: error_10.name });
                        throw new Error(error_10.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This function returns info for the funnel representation
     *
     * @param {GetFunnelInfoRequest} GetFunnelInfoRequest The array of types, since and until date.
     *
     */
    PanelAccess.prototype.getFunnelInfo = function (getFunnelInfoRequest, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_9, e, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.getFunnelInfo(getFunnelInfoRequest)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('getFunnelInfo from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getFunnelInfo(getFunnelInfoRequest, false)];
                    case 5:
                        res_9 = _a.sent();
                        return [2 /*return*/, res_9];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('getFunnelInfo status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_11 = _a.sent();
                        logger.error('Error getFunnelInfo', { msg: error_11.message, name: error_11.name });
                        throw new Error(error_11.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This function returns the data of an admin
     *
     */
    PanelAccess.prototype.getAdminData = function (renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_10, e, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.getAdminData()];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('getAdminData from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getAdminData(false)];
                    case 5:
                        res_10 = _a.sent();
                        return [2 /*return*/, res_10];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('getAdminData status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_12 = _a.sent();
                        logger.error('Error getAdminData', { msg: error_12.message, name: error_12.name });
                        throw new Error(error_12.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This function updates the data of an admin
     *
     */
    PanelAccess.prototype.updateAdminData = function (data, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_11, e, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.updateAdminData(data)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('updateAdminData from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.updateAdminData(data, false)];
                    case 5:
                        res_11 = _a.sent();
                        return [2 /*return*/, res_11];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('updateAdminData status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_13 = _a.sent();
                        logger.error('Error updateAdminData', { msg: error_13.message, name: error_13.name });
                        throw new Error(error_13.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This function return some global information
     *
     * @param {GetGlobalOverviewRequest} getGlobalOverviewRequest since and until date.
     *
     */
    PanelAccess.prototype.getGlobalOverview = function (getGlobalOverviewRequest, renew) {
        if (getGlobalOverviewRequest === void 0) { getGlobalOverviewRequest = {}; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_12, e, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.getGlobalOverview(getGlobalOverviewRequest)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('getGlobalOverview from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getGlobalOverview(getGlobalOverviewRequest, false)];
                    case 5:
                        res_12 = _a.sent();
                        return [2 /*return*/, res_12];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('getGlobalOverview status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_14 = _a.sent();
                        logger.error('Error getGlobalOverview', { msg: error_14.message, name: error_14.name });
                        throw new Error(error_14.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Publish campaign without paying
     *
     * @param {string} campaignId campaignId.
     *
     */
    PanelAccess.prototype.publishCampaign = function (campaignId, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_13, e, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.publishCampaignPanel(campaignId)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('publishCampaign from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.publishCampaign(campaignId, false)];
                    case 5:
                        res_13 = _a.sent();
                        return [2 /*return*/, res_13];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('publishCampaign status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_15 = _a.sent();
                        logger.error('Error publishCampaign', { msg: error_15.message, name: error_15.name });
                        throw new Error(error_15.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get campaign info, testers, links and global audience summary
     *
     * @param {string} campaignId campaignId.
     *
     */
    PanelAccess.prototype.getCampaignByCampaignId = function (campaignId, sinceDate, untilDate, renew) {
        if (sinceDate === void 0) { sinceDate = 0; }
        if (untilDate === void 0) { untilDate = Date.now(); }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_14, e, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.getCampaignByCampaignId(campaignId, sinceDate, untilDate)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('getCampaignByCampaignId from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getCampaignByCampaignId(campaignId, sinceDate, untilDate, false)];
                    case 5:
                        res_14 = _a.sent();
                        return [2 /*return*/, res_14];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('getCampaignByCampaignId status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_16 = _a.sent();
                        logger.error('Error getCampaignByCampaignId', { msg: error_16.message, name: error_16.name });
                        throw new Error(error_16.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update campaign item
     *
     * @param {CampaignItem} campaign
     * @param {CampaignPrimaryKey} campaignPrimaryKey
     *
     */
    PanelAccess.prototype.updateCampaign = function (campaign, campaignPrimaryKey, renew) {
        if (campaignPrimaryKey === void 0) { campaignPrimaryKey = undefined; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_15, e, error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.updateCampaignPanel(campaign, campaignPrimaryKey)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('updateCampaignPanel from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.updateCampaign(campaign, campaignPrimaryKey, false)];
                    case 5:
                        res_15 = _a.sent();
                        return [2 /*return*/, res_15];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('updateCampaignPanel status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_17 = _a.sent();
                        logger.error('Error updateCampaignPanel', { msg: error_17.message, name: error_17.name });
                        throw new Error(error_17.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Test method for preloading assets in the indexedDB local storage.
     * It tries to retrieve the file from local or dowload and stores the assets.
     * Either way it returns a local blob url.
     *
     * @param {string} fileName The name of the file
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<SAS>} Shared access credentials
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    PanelAccess.prototype.getFile = function (userId, fileName, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var blob, blobFromDb, error_18, res, sas, res2, fileItem, error_19, campaigns, error_20, blobURL;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        blobFromDb = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, dexie_db_1.default.table('files').where('fileName').equals(fileName).toArray()];
                    case 2:
                        blobFromDb = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_18 = _a.sent();
                        console.log('db error getFile 1', { error: error_18 });
                        return [3 /*break*/, 4];
                    case 4:
                        if (!(blobFromDb.length === 0)) return [3 /*break*/, 21];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 19, , 20]);
                        return [4 /*yield*/, this.api.getPanelFile(userId, fileName)];
                    case 6:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 14];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        sas = _a.sent();
                        return [4 /*yield*/, fetch(sas.uri)];
                    case 8:
                        res2 = _a.sent();
                        return [4 /*yield*/, res2.blob()];
                    case 9:
                        blob = _a.sent();
                        fileItem = {
                            id: fileName,
                            fileName: fileName,
                            storedAt: Date.now(),
                            blob: blob
                        };
                        _a.label = 10;
                    case 10:
                        _a.trys.push([10, 12, , 13]);
                        return [4 /*yield*/, dexie_db_1.default.table('files').put(fileItem)];
                    case 11:
                        _a.sent();
                        return [3 /*break*/, 13];
                    case 12:
                        error_19 = _a.sent();
                        console.log('db error getFile 2', { error: error_19 });
                        return [3 /*break*/, 13];
                    case 13: return [3 /*break*/, 18];
                    case 14:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 17];
                        return [4 /*yield*/, this._authRenewal()];
                    case 15:
                        _a.sent();
                        return [4 /*yield*/, this.getFile(userId, fileName, false)];
                    case 16:
                        campaigns = _a.sent();
                        return [2 /*return*/, campaigns];
                    case 17: throw new errors_1.PermissionError('Invalid access token');
                    case 18: return [3 /*break*/, 20];
                    case 19:
                        error_20 = _a.sent();
                        throw new Error(error_20.message);
                    case 20: return [3 /*break*/, 22];
                    case 21:
                        blob = blobFromDb[0].blob;
                        _a.label = 22;
                    case 22: return [4 /*yield*/, URL.createObjectURL(blob)];
                    case 23:
                        blobURL = _a.sent();
                        return [2 /*return*/, { token: 'none', uri: blobURL }];
                }
            });
        });
    };
    ;
    /**
     * Test method for preloading assets in the indexedDB local storage
     * it tries to retrieve the file from local or dowload and stores the assets.
     * either way returns a local blob url.
     *
     * @param {string} fileName
     * @param {function} progress A callback function with the progress
     *
     * @returns {Promise<SAS>}  Shared access credentials
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    PanelAccess.prototype.getFilmFile = function (campaignId, userId, fileName, progress, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var blob, blobFromDb, error_21, res, sas, campaigns, error_22, blobURL;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        blobFromDb = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, dexie_db_1.default.table('files').where('fileName').equals(fileName).toArray()];
                    case 2:
                        blobFromDb = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_21 = _a.sent();
                        console.log('db error getFilmFile 1', { error: error_21 });
                        return [3 /*break*/, 4];
                    case 4:
                        if (!(blobFromDb.length === 0)) return [3 /*break*/, 16];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 14, , 15]);
                        return [4 /*yield*/, this.api.getPanelFilmFile(campaignId, userId, fileName)];
                    case 6:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 9];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        sas = _a.sent();
                        return [4 /*yield*/, fetch(sas.url).then(fetch_progress_1.default({
                                onProgress: function (e) {
                                    if (progress)
                                        progress(e);
                                },
                            })).then(function (res2) { return res2.blob(); }).then(function (blobResponse) { return __awaiter(_this, void 0, void 0, function () {
                                var fileItem, error_23;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            blob = blobResponse;
                                            fileItem = {
                                                id: fileName,
                                                fileName: fileName,
                                                storedAt: Date.now(),
                                                blob: blob
                                            };
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, dexie_db_1.default.table('files').put(fileItem)];
                                        case 2:
                                            _a.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            error_23 = _a.sent();
                                            console.log('db error getFilmFile 2', { error: error_23 });
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 8:
                        _a.sent();
                        return [3 /*break*/, 13];
                    case 9:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 12];
                        return [4 /*yield*/, this._authRenewal()];
                    case 10:
                        _a.sent();
                        return [4 /*yield*/, this.getFilmFile(campaignId, userId, fileName, progress, false)];
                    case 11:
                        campaigns = _a.sent();
                        return [2 /*return*/, campaigns];
                    case 12: throw new errors_1.PermissionError('Invalid access token');
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        error_22 = _a.sent();
                        throw new errors_1.PermissionError(error_22.message);
                    case 15: return [3 /*break*/, 17];
                    case 16:
                        blob = blobFromDb[0].blob;
                        _a.label = 17;
                    case 17: return [4 /*yield*/, URL.createObjectURL(blob)];
                    case 18:
                        blobURL = _a.sent();
                        return [2 /*return*/, { token: 'none', uri: blobURL }];
                }
            });
        });
    };
    ;
    return PanelAccess;
}());
exports.default = PanelAccess;
//# sourceMappingURL=PanelAccess.js.map